import React from 'react';
import { useParams } from 'react-router-dom';
import { Report1, Report2, Report3 } from '../../reports';

export const Report = () => {
  const { reportId } = useParams();
  
  // Map report IDs to their corresponding components
  const reportComponents = {
    1: Report1,
    2: Report2,
    3: Report3,
  };
  
  // Get the appropriate report component or default to Report1
  const ReportComponent = reportComponents[parseInt(reportId)] || Report1;
  
  return <ReportComponent />;
};

export default Report;

